import {
  CREATE_ARTIST,
  DELETE_ARTIST,
  GET_ALL_ARTIST,
  UPDATE_ARTIST,
} from "../../../api/endPoint";
import instance from "../../../helpers/axios";

const getAllArtist = () => {
  return instance.get(GET_ALL_ARTIST);
};

const createArtist = (data) => {
  const body = {
    name: data?.artistname,
    bio: [data?.aboutartist],
    image: data.thumbnailfile,
  };
  const ig = (data?.instagramurl || "").trim();
  if (ig) body.instagramurl = ig;
  return instance.post(CREATE_ARTIST, body);
};

const updateArtist = (data) => {
  const requestData = {
    name: data?.artistname,
    bio: [data?.aboutartist],
    id: data?.id,
  };

  if (data?.thumbnailfile) {
    requestData.image = data?.thumbnailfile || "";
  }
  if (data?.instagramurl !== undefined) {
    requestData.instagramurl = data.instagramurl;
  }
  return instance.put(UPDATE_ARTIST, requestData);
  // return instance.put(UPDATE_ARTIST, {
  //   name: data?.artistname,
  //   bio: [data?.aboutartist],
  //   image:  data?.thumbnailfile ? data?.thumbnailfile[0]?.name : '',
  //   id: data?.id,
  // });
};

const deleteArtist = (id) => {
  return instance.put(`${DELETE_ARTIST}/${id}`);
};

const artistService = {
  getAllArtist,
  createArtist,
  updateArtist,
  deleteArtist,
};

export default artistService;
